import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { rateAnswer, requestForUpdate } from "../../API/api";
import styles from "./RatingStyles.module.css";
import { Actions } from "../../Action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const Voting = ({helpful, answer}) => {
    const [upVote, setUpVote] = useState(answer.isHelpful);
    const [downVote, setDownVote] = useState(answer.isReject);
    const searchState = useSelector(state=>state.search);
    const dispatch = useDispatch();
  const helpfulTrigger = () => {
    if(helpful === undefined){
      return;
    }
    requestForUpdate(helpful)
      .then((res) => {
        if (res !== undefined) {
          toast.success(successfulHelpful(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
          
        }
      })
      .catch((err) => {});
  };

  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const onClickThumbs = (key) => {
    if(key === 'up'){
        if(upVote === true){
          return;
        }
        helpful.status = 'accepted';
        setUpVote(true);
        setDownVote(false);
        answer.isHelpful = true;
        answer.isReject = false;
    }
    if(key === 'down'){
      if(downVote === true){
        return;
      }
        helpful.status = 'reject';
        setUpVote(false);
        setDownVote(true);
        answer.isHelpful = false;
        answer.isReject = true;
    }
    helpfulTrigger();
  };

  const renderTooltipBad = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Bad Response
    </Tooltip>
  );
  const renderTooltipGood = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Good Response
    </Tooltip>
  );
  useEffect(()=>{

  },[searchState.searchData]);
  return (
      <div className={styles.ratingDiv}>
        <OverlayTrigger
        placement="top"
        overlay={renderTooltipBad}
        >
        <span
          className={styles.thumbsDown}
          onClick={() => onClickThumbs('down')}
            style={{ color: downVote?'red':null}}
        >
          <i className="fa fa-solid fa-thumbs-down fa-border-all"></i>
        </span>
        </OverlayTrigger>
        <OverlayTrigger
        placement="top"
        overlay={renderTooltipGood}
        >
        <span
            className={styles.thumbsDoubleUp}
            onClick={() => onClickThumbs('up')}
            style={{color:upVote?"#A4BE7B":null}}
        >
          <i className="fa fa-solid fa-thumbs-up fa-border-all"></i>
        </span>
        </OverlayTrigger>
      </div>
  );
};

export default Voting;
